import React, { useEffect, useState } from 'react';
import DSDataLoader from 'Pages/directSurvey/components/dataLoader';
import DSTopContent from 'Pages/directSurvey/components/topContent';
import { AutoEmailRoot } from 'Pages/directSurvey/style';
import { INDEX_TEST_ID } from 'Pages/directSurvey/testId';
import SurveyPrompt from 'Pages/surveyExperience/components/surveyPrompt/SurveyPrompt';
import EmailAutoLoginGuard from 'Shared/components/design/email/autoLoginGuard';
import EmailGenericError from 'Shared/components/design/email/genericError';
import AERedirecting from 'Shared/components/design/email/redirecting';
import { useQueryParam } from 'Shared/hooks/useQueryParam';

/**
 * Renders the DirectSurvey page
 */
function DirectSurvey(): JSX.Element {
  const userId                          = useQueryParam('userId') ?? '';
  const aeId                            = useQueryParam('aeId') ?? '';
  const aeCId                           = useQueryParam('aeCId') ?? '';
  const aeT                             = useQueryParam('aeT', true) ?? '';
  const directSurveyKey                 = useQueryParam('directSurveyKey') ?? '';
  const autoLoginKey                    = useQueryParam('autoLoginKey') ?? '';
  const surveyId                        = useQueryParam('surveyId') ?? '';
  const pId                             = useQueryParam('pId') ?? '';
  const [doneLoading, setDoneLoading]   = useState(false);
  const [stillLoading, setStillLoading] = useState(false);
  const [redirecting, setRedirecting]   = useState(false);

  useEffect(() => {
    if (doneLoading) {
      return;
    }

    const waitInSeconds         = parseInt(process.env.DIRECT_SURVEY_REDIRECT_WAIT_SECONDS || '7') * 1000;
    const stillLoadingTimeoutId = setTimeout(() => setStillLoading(true), 3000);
    const redirectingTimeoutId  = setTimeout(() => setRedirecting(true), waitInSeconds);
    return () => {
      clearTimeout(stillLoadingTimeoutId);
      clearTimeout(redirectingTimeoutId);
    };
  }, [doneLoading]);

  function renderContent () {
    if (redirecting) {
      return (
        <AERedirecting reason={'too-long'} />
      );
    } else if (!userId || !aeId || !aeCId || !surveyId || !pId || !aeT || !directSurveyKey || !autoLoginKey) {
      return (
        <EmailGenericError />
      );
    } else {
      return (
        <EmailAutoLoginGuard userId={userId} aeT={aeT} autoLoginKey={autoLoginKey} stillLoading={stillLoading}>
          <DSDataLoader
            aeId            = {aeId}
            aeCId           = {aeCId}
            aeT             = {aeT}
            directSurveyKey = {directSurveyKey}
            surveyId        = {surveyId}
            pId             = {pId}
            stillLoading    = {stillLoading}
            setDoneLoading  = {setDoneLoading}
          />
        </EmailAutoLoginGuard>
      );
    }
  }

  return (
    <AutoEmailRoot data-testid={INDEX_TEST_ID}>
      <DSTopContent />
      {renderContent()}
      <SurveyPrompt isAutoEmail={true} />
    </AutoEmailRoot>
  );
}

export default DirectSurvey;
